import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { LiabilitiesWidgetTablePropType } from './LiabilitiesWidgetTable.types';
import { LiabilitiesWidgetTableState } from './LiabilitiesWidgetTable.state';
import { useAppStateContext } from 'src/AppState/AppState';
import { Table, TableHeader, TableSubMenu } from './components';
import { MULTIPLES_DEFAULT_COLUMN_IDS, SINGLES_VISIBLE_COLUMNS } from './LiabilitiesWidgetTable.consts';

export const LiabilitiesWidgetTable = observer(
    'LiabilitiesWidgetTable',
    ({ eventId, marketId, onCloseRequest, singlesTableView }: LiabilitiesWidgetTablePropType) => {
        const { sdkStaff, trpcClient } = useAppStateContext();
        const currency = 'GBP';

        const [liabilitiesState] = useState(
            () => new LiabilitiesWidgetTableState(sdkStaff, trpcClient, marketId, eventId, singlesTableView)
        );

        const { liabilities, allSelections } = liabilitiesState;

        if (liabilitiesState.state === 'FETCHING') {
            return <div>Loading...</div>;
        }

        if (liabilitiesState.state === 'ERROR') {
            return <div>Error</div>;
        }

        const { eventName, marketName, column, direction, setSortDirection, setSortedColumn, view, setTableView } =
            liabilitiesState;

        const isMultiplesWidget = singlesTableView === undefined || singlesTableView === false;

        const columns = isMultiplesWidget ? MULTIPLES_DEFAULT_COLUMN_IDS : SINGLES_VISIBLE_COLUMNS[view];

        return (
            <div className='market-liabilities'>
                {isMultiplesWidget ? (
                    <>
                        <TableSubMenu
                            handleClose={onCloseRequest}
                            setTableView={setTableView}
                            isMultiplesWidget={isMultiplesWidget}
                            view={view}
                        />
                        <TableHeader
                            eventName={eventName}
                            marketName={marketName}
                            isMultiplesWidget={isMultiplesWidget}
                        />
                    </>
                ) : (
                    <>
                        <TableHeader
                            eventName={eventName}
                            marketName={marketName}
                            isMultiplesWidget={isMultiplesWidget}
                        />
                        <TableSubMenu
                            handleClose={onCloseRequest}
                            setTableView={setTableView}
                            isMultiplesWidget={isMultiplesWidget}
                            view={view}
                        />
                    </>
                )}
                <Table
                    columns={columns}
                    isMultiplesWidget={isMultiplesWidget}
                    liabilities={liabilities}
                    selections={allSelections}
                    setSortDirection={setSortDirection}
                    setSortedColumn={setSortedColumn}
                    sortColumn={column}
                    sortDirection={direction}
                    currency={currency}
                    eventId={eventId}
                />
            </div>
        );
    }
);
